import type { SxProps, Theme } from "@mui/material/styles";

import { frameNavItemSx } from "./frameNavItemSx";

/**
 * The current app's icon at the top of the collapsed sidebar. Drawn the same
 * as the selected app in the expanded icon rail (AppsSideBar) so the two views
 * agree in both colour modes. Unlike the rail it has no left nudge: here it
 * centres over the menu icons below it.
 */
export const collapsedAppIconSx: SxProps<Theme> = [
  frameNavItemSx(true),
  { borderRadius: "8px" },
];
